var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"w-7 h-7",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M8.25 4.5l7.5 7.5-7.5 7.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }